<script>
    import { Line } from 'vue-chartjs'

    export default {
        extends: Line,
        props: ['dadosGrafico'],
        mounted () {
            this.renderChart({
                labels: [
                    'Janeiro',
                    'Fevereiro',
                    'Março',
                    'Abril',
                    'Maio',
                    'Junho',
                    'Julho',
                    'Agosto',
                    'Setembro',
                    'Outubro',
                    'Novembro',
                    'Dezembro'
                ],
                datasets: [
                    {
                        label: 'Indicação de leads',
                        backgroundColor: 'rgba(255, 111, 0, .2)',
                        borderColor: 'rgba(255, 111, 0, 1)',
                        pointBackgroundColor: 'rgba(255, 111, 0, 1)',
                        pointBorderColor: 'rgba(255, 111, 0, 1)',
                        pointHoverBackgroundColor: 'rgba(255, 111, 0, 1)',
                        pointHoverBorderColor: 'rgba(255, 111, 0, 1)',
                        data: [
                            this.dadosGrafico.indicacao.jan,
                            this.dadosGrafico.indicacao.fev,
                            this.dadosGrafico.indicacao.mar,
                            this.dadosGrafico.indicacao.abr,
                            this.dadosGrafico.indicacao.mai,
                            this.dadosGrafico.indicacao.jun,
                            this.dadosGrafico.indicacao.jul,
                            this.dadosGrafico.indicacao.ago,
                            this.dadosGrafico.indicacao.set,
                            this.dadosGrafico.indicacao.out,
                            this.dadosGrafico.indicacao.nov,
                            this.dadosGrafico.indicacao.dez,
                        ]
                    },
                    {
                        label: 'Processo não iniciado',
                        backgroundColor: 'rgba(213,0,249,.2)',
                        borderColor: 'rgba(213,0,249,1)',
                        pointBackgroundColor: 'rgba(213,0,249,1)',
                        pointBorderColor: 'rgba(213,0,249,1)',
                        pointHoverBackgroundColor: 'rgba(213,0,249,1)',
                        pointHoverBorderColor: 'rgba(213,0,249,1)',
                        data: [
                            this.dadosGrafico.naoIniciado.jan,
                            this.dadosGrafico.naoIniciado.fev,
                            this.dadosGrafico.naoIniciado.mar,
                            this.dadosGrafico.naoIniciado.abr,
                            this.dadosGrafico.naoIniciado.mai,
                            this.dadosGrafico.naoIniciado.jun,
                            this.dadosGrafico.naoIniciado.jul,
                            this.dadosGrafico.naoIniciado.ago,
                            this.dadosGrafico.naoIniciado.set,
                            this.dadosGrafico.naoIniciado.out,
                            this.dadosGrafico.naoIniciado.nov,
                            this.dadosGrafico.naoIniciado.dez,
                        ]
                    },
                    {
                        label: 'Contato',
                        backgroundColor: 'rgba(123, 31, 162, .2)',
                        borderColor: 'rgba(123, 31, 162, 1)',
                        pointBackgroundColor: 'rgba(123, 31, 162, 1)',
                        pointBorderColor: 'rgba(123, 31, 162, 1)',
                        pointHoverBackgroundColor: 'rgba(123, 31, 162, 1)',
                        pointHoverBorderColor: 'rgba(123, 31, 162, 1)',
                        data: [
                            this.dadosGrafico.contato.jan,
                            this.dadosGrafico.contato.fev,
                            this.dadosGrafico.contato.mar,
                            this.dadosGrafico.contato.abr,
                            this.dadosGrafico.contato.mai,
                            this.dadosGrafico.contato.jun,
                            this.dadosGrafico.contato.jul,
                            this.dadosGrafico.contato.ago,
                            this.dadosGrafico.contato.set,
                            this.dadosGrafico.contato.out,
                            this.dadosGrafico.contato.nov,
                            this.dadosGrafico.contato.dez,
                        ]
                    },
                    {
                        label: 'Visita',
                        backgroundColor: 'rgba(2,136,209,.2)',
                        borderColor: 'rgba(2,136,209,1)',
                        pointBackgroundColor: 'rgba(2,136,209,1)',
                        pointBorderColor: 'rgba(2,136,209,1)',
                        pointHoverBackgroundColor: 'rgba(2,136,209,1)',
                        pointHoverBorderColor: 'rgba(2,136,209,1)',
                        data: [
                            this.dadosGrafico.visita.jan,
                            this.dadosGrafico.visita.fev,
                            this.dadosGrafico.visita.mar,
                            this.dadosGrafico.visita.abr,
                            this.dadosGrafico.visita.mai,
                            this.dadosGrafico.visita.jun,
                            this.dadosGrafico.visita.jul,
                            this.dadosGrafico.visita.ago,
                            this.dadosGrafico.visita.set,
                            this.dadosGrafico.visita.out,
                            this.dadosGrafico.visita.nov,
                            this.dadosGrafico.visita.dez,
                        ]
                    },
                    {
                        label: 'Em negociação',
                        backgroundColor: 'rgba(79,195,247,.2)',
                        borderColor: 'rgba(79,195,247,1)',
                        pointBackgroundColor: 'rgba(79,195,247,1)',
                        pointBorderColor: 'rgba(79,195,247,1)',
                        pointHoverBackgroundColor: 'rgba(79,195,247,1)',
                        pointHoverBorderColor: 'rgba(79,195,247,1)',
                        data: [
                            this.dadosGrafico.cold.jan+this.dadosGrafico.negociacao.jan,
                            this.dadosGrafico.cold.fev+this.dadosGrafico.negociacao.fev,
                            this.dadosGrafico.cold.mar+this.dadosGrafico.negociacao.mar,
                            this.dadosGrafico.cold.abr+this.dadosGrafico.negociacao.abr,
                            this.dadosGrafico.cold.mai+this.dadosGrafico.negociacao.mai,
                            this.dadosGrafico.cold.jun+this.dadosGrafico.negociacao.jun,
                            this.dadosGrafico.cold.jul+this.dadosGrafico.negociacao.jul,
                            this.dadosGrafico.cold.ago+this.dadosGrafico.negociacao.ago,
                            this.dadosGrafico.cold.set+this.dadosGrafico.negociacao.set,
                            this.dadosGrafico.cold.out+this.dadosGrafico.negociacao.out,
                            this.dadosGrafico.cold.nov+this.dadosGrafico.negociacao.nov,
                            this.dadosGrafico.cold.dez+this.dadosGrafico.negociacao.dez,
                        ]
                    },
                    {
                        label: 'Efetivado',
                        backgroundColor: 'rgba(67, 160, 71, .2)',
                        borderColor: 'rgba(67, 160, 71, 1)',
                        pointBackgroundColor: 'rgba(67, 160, 71, 1)',
                        pointBorderColor: 'rgba(67, 160, 71, 1)',
                        pointHoverBackgroundColor: 'rgba(67, 160, 71, 1)',
                        pointHoverBorderColor: 'rgba(67, 160, 71, 1)',
                        data: [
                            this.dadosGrafico.efetivado.jan,
                            this.dadosGrafico.efetivado.fev,
                            this.dadosGrafico.efetivado.mar,
                            this.dadosGrafico.efetivado.abr,
                            this.dadosGrafico.efetivado.mai,
                            this.dadosGrafico.efetivado.jun,
                            this.dadosGrafico.efetivado.jul,
                            this.dadosGrafico.efetivado.ago,
                            this.dadosGrafico.efetivado.set,
                            this.dadosGrafico.efetivado.out,
                            this.dadosGrafico.efetivado.nov,
                            this.dadosGrafico.efetivado.dez,
                        ]
                    },
                    {
                        label: 'Não efetivado',
                        backgroundColor: 'rgba(255, 82, 82, .2)',
                        borderColor: 'rgba(255, 82, 82, 1)',
                        pointBackgroundColor: 'rgba(255, 82, 82, 1)',
                        pointBorderColor: 'rgba(255, 82, 82, 1)',
                        pointHoverBackgroundColor: 'rgba(255, 82, 82, 1)',
                        pointHoverBorderColor: 'rgba(255, 82, 82, 1)',
                        data: [
                            this.dadosGrafico.lost.jan+this.dadosGrafico.negativado.jan,
                            this.dadosGrafico.lost.fev+this.dadosGrafico.negativado.fev,
                            this.dadosGrafico.lost.mar+this.dadosGrafico.negativado.mar,
                            this.dadosGrafico.lost.abr+this.dadosGrafico.negativado.abr,
                            this.dadosGrafico.lost.mai+this.dadosGrafico.negativado.mai,
                            this.dadosGrafico.lost.jun+this.dadosGrafico.negativado.jun,
                            this.dadosGrafico.lost.jul+this.dadosGrafico.negativado.jul,
                            this.dadosGrafico.lost.ago+this.dadosGrafico.negativado.ago,
                            this.dadosGrafico.lost.set+this.dadosGrafico.negativado.set,
                            this.dadosGrafico.lost.out+this.dadosGrafico.negativado.out,
                            this.dadosGrafico.lost.nov+this.dadosGrafico.negativado.nov,
                            this.dadosGrafico.lost.dez+this.dadosGrafico.negativado.dez,
                        ]
                    },
                    {
                        label: 'Total',
                        backgroundColor: 'rgba(191,54,12,.2)',
                        borderColor: 'rgba(191,54,12,1)',
                        pointBackgroundColor: 'rgba(191,54,12,1)',
                        pointBorderColor: 'rgba(191,54,12,1)',
                        pointHoverBackgroundColor: 'rgba(191,54,12,1)',
                        pointHoverBorderColor: 'rgba(191,54,12,1)',
                        data: this.getTotal()
                    },
                ]
            }, {responsive: true, maintainAspectRatio: false})
        },
        methods: {
            getTotal() {
                return [
                    this.dadosGrafico.cold.jan+this.dadosGrafico.negociacao.jan+this.dadosGrafico.contato.jan+this.dadosGrafico.efetivado.jan+this.dadosGrafico.indicacao.jan+this.dadosGrafico.lost.jan+this.dadosGrafico.negativado.jan+this.dadosGrafico.naoIniciado.jan+this.dadosGrafico.visita.jan,
                    this.dadosGrafico.cold.fev+this.dadosGrafico.negociacao.fev+this.dadosGrafico.contato.fev+this.dadosGrafico.efetivado.fev+this.dadosGrafico.indicacao.fev+this.dadosGrafico.lost.fev+this.dadosGrafico.negativado.fev+this.dadosGrafico.naoIniciado.fev+this.dadosGrafico.visita.fev,
                    this.dadosGrafico.cold.mar+this.dadosGrafico.negociacao.mar+this.dadosGrafico.contato.mar+this.dadosGrafico.efetivado.mar+this.dadosGrafico.indicacao.mar+this.dadosGrafico.lost.mar+this.dadosGrafico.negativado.mar+this.dadosGrafico.naoIniciado.mar+this.dadosGrafico.visita.mar,
                    this.dadosGrafico.cold.abr+this.dadosGrafico.negociacao.abr+this.dadosGrafico.contato.abr+this.dadosGrafico.efetivado.abr+this.dadosGrafico.indicacao.abr+this.dadosGrafico.lost.abr+this.dadosGrafico.negativado.abr+this.dadosGrafico.naoIniciado.abr+this.dadosGrafico.visita.abr,
                    this.dadosGrafico.cold.mai+this.dadosGrafico.negociacao.mai+this.dadosGrafico.contato.mai+this.dadosGrafico.efetivado.mai+this.dadosGrafico.indicacao.mai+this.dadosGrafico.lost.mai+this.dadosGrafico.negativado.mai+this.dadosGrafico.naoIniciado.mai+this.dadosGrafico.visita.mai,
                    this.dadosGrafico.cold.jun+this.dadosGrafico.negociacao.jun+this.dadosGrafico.contato.jun+this.dadosGrafico.efetivado.jun+this.dadosGrafico.indicacao.jun+this.dadosGrafico.lost.jun+this.dadosGrafico.negativado.jun+this.dadosGrafico.naoIniciado.jun+this.dadosGrafico.visita.jun,
                    this.dadosGrafico.cold.jul+this.dadosGrafico.negociacao.jul+this.dadosGrafico.contato.jul+this.dadosGrafico.efetivado.jul+this.dadosGrafico.indicacao.jul+this.dadosGrafico.lost.jul+this.dadosGrafico.negativado.jul+this.dadosGrafico.naoIniciado.jul+this.dadosGrafico.visita.jul,
                    this.dadosGrafico.cold.ago+this.dadosGrafico.negociacao.ago+this.dadosGrafico.contato.ago+this.dadosGrafico.efetivado.ago+this.dadosGrafico.indicacao.ago+this.dadosGrafico.lost.ago+this.dadosGrafico.negativado.ago+this.dadosGrafico.naoIniciado.ago+this.dadosGrafico.visita.ago,
                    this.dadosGrafico.cold.set+this.dadosGrafico.negociacao.set+this.dadosGrafico.contato.set+this.dadosGrafico.efetivado.set+this.dadosGrafico.indicacao.set+this.dadosGrafico.lost.set+this.dadosGrafico.negativado.set+this.dadosGrafico.naoIniciado.set+this.dadosGrafico.visita.set,
                    this.dadosGrafico.cold.out+this.dadosGrafico.negociacao.out+this.dadosGrafico.contato.out+this.dadosGrafico.efetivado.out+this.dadosGrafico.indicacao.out+this.dadosGrafico.lost.out+this.dadosGrafico.negativado.out+this.dadosGrafico.naoIniciado.out+this.dadosGrafico.visita.out,
                    this.dadosGrafico.cold.nov+this.dadosGrafico.negociacao.nov+this.dadosGrafico.contato.nov+this.dadosGrafico.efetivado.nov+this.dadosGrafico.indicacao.nov+this.dadosGrafico.lost.nov+this.dadosGrafico.negativado.nov+this.dadosGrafico.naoIniciado.nov+this.dadosGrafico.visita.nov,
                    this.dadosGrafico.cold.dez+this.dadosGrafico.negociacao.dez+this.dadosGrafico.contato.dez+this.dadosGrafico.efetivado.dez+this.dadosGrafico.indicacao.dez+this.dadosGrafico.lost.dez+this.dadosGrafico.negativado.dez+this.dadosGrafico.naoIniciado.dez+this.dadosGrafico.visita.dez,
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/GraficoLinha.vue